<template>
  <PageLayout>
    <div class="page-lotteryHall">
      <Appbar class="flex-shrink-0" routeNameProps="lotteryhall" :title="title">
        <span v-if="showBottomTab" text slot="left"></span>
      </Appbar>
      <v-card :dark="isDark" class="lottery-tab-container" color="transparent">
        <component v-if="_config" :is="
            _config.app_config.configValue.template
              ? _config.app_config.configValue.template.lottery || 'default1'
              : 'default1'
          " />
      </v-card>
      <BottomTab />
    </div>
  </PageLayout>
</template>

<script>
import appConfigMixins from '@c/mixins/appConfig.mixins'
import Appbar from '@c/layout/Appbar'
import PageLayout from '@c/layout/PageLayout'
import BottomTab from '@c/layout/BottomTab'
export default {
  mixins: [appConfigMixins],
  components: {
    PageLayout,
    Appbar,
    BottomTab,
    default1: () => import('@t/LotteryHall/default1'),
    Venice01: () => import('@t/LotteryHall/Venice01'),
    nox: () => import('@t/LotteryHall/nox')
  },
  computed: {
    title() {
      try {
        return this.app_my_config.lotteryHall.name
      } catch { }
    }
  }
}
</script>

<style lang="scss">
.page-lotteryHall {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .lottery-tab-container {
    overflow: hidden;
    display: flex;
    position: relative;
    flex-grow: 1;
    flex-direction: column;
    border-radius: 0 !important;
  }
}
</style>
